// extracted by mini-css-extract-plugin
export default {"details__topBarContainer":"AdminOpcosView_details__topBarContainer__g9Fzh"};